/**
 * Created by Administrator on 2017/9/29.
 */
import des from './des';

//var server = 'http://szxx.beijing.gov.cn/szxxnew';
//var server = window.location.origin+'/szxxnew';

var server = '/szxxnew';
// 生产
var wsxfServer = 'https://wsxf.xfb.beijing.gov.cn/wsxf';
// 测试
// var wsxfServer = '/wsxf';

var sessionId = sessionStorage.getItem("sessionId");
var userId = sessionStorage.getItem("userId");
export default {
  urls() {
    return {
      server,
      loginUrl: server + '/rest/logonNew',//登录
      datasUrl: server + '/rest/xfsys',//字典
      logOutUrl: server + '/rest/logout',//退出
      sessionId: sessionId,
      userId: userId,
      userType: sessionStorage.getItem("userType"),
      useridUrl: server + '/rest/users/userNum',//获取用户基础信息
      usertypeUrl: server + '/users/usertype',//获取用户类型
      userInfoUrl: server + '/rest/users/loadMyInfo',//获取用户全部信息
      getPassWordUrl: server + '/rest/users/password/resetWithJson/',//重置密码
      changePassWordUrl: server + '/rest/users/password/update/withJson',//修改密码
      changePhoneUrl: server + '/rest/users/mobilePhone/update/withJson',//修改手机
      registerUserUrl: server + '/rest/users/registerWithJson',//注册
      edituserUrl: server + '/rest/users/withJson',//更改个人信息
      chackVirtualMobilePhone: server + '/rest/users/chackVirtualMobilePhone',//校验是否是虚拟号段手机号码
      approveUrl: server + '/rest/users/verify/withJson',//实名认证
      registerDatasUrl: server + '/rest/users/register/init',//注册，下拉信息
      getLetterUrl: server + '/rest/letters',//获取信件列表
      getLetterDetailUrl: server + '/rest/letters/',//获取信件详情
      showFileUrl: server + '/rest/attachments/',//下载附件
      filesUrl: server + '/rest/attachments',//附件列表
      returnFilessUrl: server + '/letters/att/download',//办理反馈的附件列表
      subCommontUrl: server + '/rest/letters/',//提交评价
      writeLetterUrl: server + '/rest/letters/submit/withJson',//提交或者更改信件信息
      writeCheckUrl: server + '/rest/letters/checkCanWriteLetter',//验证写信时间
      verifyCodeUrl: server + '/rest/verifyCodes/generate',//图片验证码
      uploadFileUrl: server + '/rest/attachments',//上传文件
      modifyPhoneCode: server + '/rest/register/changeMobileSmsCode',//更改手机号码获取手机验证码
      getPswPhoneCode: server + '/rest/register/smsCode',//实名认证获取手机验证码
      getPswCode: server + '/rest/resetpsw/smscode',//忘记密码获取手机验证码    
      checkPasswordUrl: server + '/users/authentCode',//实名认证 校验密码
      getCodeUrl: server + '/rest/unverified/smsCode',//实名认证 获取验证码
      bindPhoneUrl: server + '/users/checkVerifySmsCode',//实名认证 绑定手机
      verifyCertUrl: server + '/ajaxvalidate/certificateCode',//验证身份证号
      jumpTokenUrl: server + '/rest/sso/getSSOToken',
      gotowsxfUrl: wsxfServer + '/zone/sso/fromszxx/towsxf/ssologinWithMobile2?ssotoken=',//跳转
      getloginDataUrl: server + '/sso/ssoLoginWithMobile?ssotoken=',//获取登录状态信息
      getPrincipalToken: server + '/token/principal_token',//
      heartbeatUrl: server + '/heartbeat',// 写信状态下 每个10分钟 请求一次

      getMobilCodeUrl: server + '/rest/users/applyMobileVerifyCodeOfLoginByMobile',//短信登录获取手机验证码
      loginByMobileUrl: server + '/rest/loginByMobileNew',//短信登录
      getMobilCode_cancelAccountUrl: server + '/rest/users/applyMobileVerifyCodeOfWrittenOffAccount',//注销账号获取手机验证码
      cancelAccountUrl: server + '/users/writtenOffNotWithImgVerifyCode',//注销账号
      getMobilCode_modifyPasswordUrl: server + '/rest/resetpsw/applySmsCodeForResetPsw',//忘记密码-重置密码获取手机验证码
      modifyPasswordUrl_new: server + '/rest/users/password/resetPwdByMobileWithJson',//忘记密码-重置密码

      checkUseNewTemplete: server + '/rest/xfsys/checkUseNewTemplete',//检查是否使用新模版

      getSmsCode: server + '/rest/register/smsCodeWithImgCode',//注册获取手机验证码
      registerUser: server + '/rest/users/registerWithJsonNotWithImgCode',//注册新用户提交
      modifyPassword: server + '/rest/users/password/resetPwdByMobileWithJsonNotWithImgCode',//登录页面--忘记密码
      changePassWord: server + '/rest/users/password/update/jsonNotWithImgCode',//我的--修改密码
      edituser: server + '/rest/users/jsonNotWithImgCode',//我的--修改个人信息
      changePhone: server + '/rest/users/mobilePhone/update/jsonNotWithImgCode',//我的--修改绑定手机
      approve: server + '/rest/users/verify/jsonNotWithImgCode',//实名认证

      getBjtUserInfo: server + '/rest/certNoInfo',//获取京通已注册用户的信息
      // submitBjtUserInfo: server + '/rest/userCertNoCheck',//提交京通已注册用户的校验信息
      submitBjtUserInfo: server + '/rest/userCertNoCheckWithJson',//提交京通已注册用户的校验信息
      getBjtUrlList: server + '/oauth/getBjtUrlList', //打开app后，调用后端接口获取页面控制参数
      logonWithLastInfo: server + '/rest/logonWithLastInfo', //身份二次确认
      logonWithLastInfoForMobile: server + '/rest/logonWithLastInfoForMobile' //身份二次确认
    }
  },
  //读取cookies
  getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  //写cookies
  setCookie(name, value, times) {
    if (times != undefined) {
      var exp = new Date();
      exp.setTime(exp.getTime() + times);
      document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
    } else {
      document.cookie = name + "=" + escape(value) + ";path=/";
    }
  },
  getData(vue, urls, method, data, callback) {
    var self = this;
    let loginByBjt = !!Number(sessionStorage.getItem("loginByBjt"));
    // + (loginByBjt ? "?loginByBjt=true" : ""),
    vue.$http({
      url: urls,
      method: method,
      data: data,
    }).then(function (res) {
      if (res.data.sessionId) {
        // 开发时放开
        self.setCookie("SESSION",res.data.sessionId,1000*60*60*24*30);
        sessionStorage.setItem("sessionId", res.data.sessionId);
        self.urls().sessionId = res.data.sessionId;
      }
      if (res.data.userId) {
        sessionStorage.setItem("userId", res.data.userId);
        self.urls().userId = res.data.userId;
      }
      if (res.data.loginTimeOut) {
        if(loginByBjt){
          self.getUserPrincipalForH5Page(vue,() => {
            self.getData(vue, urls, method, data, callback)
          })
          return;
        }
        let url = self.urls().logOutUrl;
        self.getData(vue, url, 'get', {}, self.callBackLogOut);
        if (urls != self.urls().usertypeUrl) {
          vue.$vux.toast.show({
            type: 'text',
            text: res.data.message
          });
        }
      }
      callback(res, vue);
    }).catch(function (err) {
      console.log(err)
      vue.$vux.loading.hide()
    })
  },
  getUserPrincipalForH5Page(vue,callback){
    var self = this;
    vue.$http({
      url: "/szxxnew/oauth/getUserPrincipalForH5Page",
      method: "POST",
      data: {principalToken:sessionStorage.getItem("principalToken")},
    }).then(function (res) {
      console.log("getUserPrincipalForH5Page----",res)
      if (res.data.status == 'success') {
        sessionStorage.setItem("sessionId",res.data.sessionId);
        self.urls().sessionId = res.data.sessionId;
        callback();
      }else{
          
      }
    }).catch(function (err) {
      console.log(err)
      vue.$vux.loading.hide()
    })
  },
  copyObj(objData) {
    var obj = {};
    for (var key in objData) {
      obj[key] = objData[key];
    }
    return obj;
  },
  callBackLogOut(res, vue) {
    vue.$store.commit('toggleLogin', { login: false, lastMenu: '登录' });
    sessionStorage.removeItem('sessionId')
  },
  //des解密
  desDecryptByBase64(word, key) {
    var keyHex = des.CryptoJS.enc.Utf8.parse(key);
    var decrypted = des.CryptoJS.DES.decrypt({
      ciphertext: des.CryptoJS.enc.Base64.parse(word)
    }, keyHex, {
      mode: des.CryptoJS.mode.ECB,
      padding: des.CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(des.CryptoJS.enc.Utf8);
  },
  //des加密
  desEncryptByHex(word, key) {
    var keyHex = des.CryptoJS.enc.Utf8.parse(key);
    var encrypted = des.CryptoJS.DES.encrypt(word, keyHex, {
      mode: des.CryptoJS.mode.ECB,
      padding: des.CryptoJS.pad.Pkcs7
    });
    var d = des.CryptoJS.enc.Base64.parse(encrypted.toString());
    return des.CryptoJS.enc.Hex.stringify(d);
  },
  //des解密
  desDecryptByHex(word, key) {
    var keyHex = des.CryptoJS.enc.Utf8.parse(key);
    var d = des.CryptoJS.enc.Hex.parse(word);
    d = des.CryptoJS.enc.Base64.stringify(d);
    var decrypted = des.CryptoJS.DES.decrypt({
      ciphertext: des.CryptoJS.enc.Base64.parse(d)
    }, keyHex, {
      mode: des.CryptoJS.mode.ECB,
      padding: des.CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(des.CryptoJS.enc.Utf8);
  },
  //验证身份证号
  verifyCert(vue, cert, callback) {
    let url = this.verifyCertUrl;
    var self = this;
    vue.$http({
      url: url,
      method: 'get',
      data: { certCode, cert },
    }).then(function (res) {
      if (res.data.sessionId) {
        sessionStorage.setItem("sessionId", res.data.sessionId);
      }
      if (res.data.userId) {
        sessionStorage.setItem("userId", res.data.userId);
      }
      callback(res, vue);
      if (res.data.loginTimeOut) {
        let url = self.urls().logOutUrl;
        self.getData(vue, url, 'get', {}, self.callBackLogOut);
        vue.$vux.toast.show({
          type: 'text',
          text: res.data.message
        });
      }
      vue.$router.push({ path: '/' })
    }).catch(function (err) {
      vue.$vux.toast.show({
        type: 'text',
        text: '请求失败'
      });
      vue.$vux.loading.hide()
    })
  },
  getArg(arg) {
    if (arg.toString().split('?')[1]) {
      var argArr = arg.toString().split('?')[1].split('&');
    } else {
      return false;
    }
    let obj = {};
    let keyArr = [];
    argArr.forEach(function (el, ind, arr) {
      let elArr = el.split('=');
      obj[elArr[0]] = elArr[1];
    });
    return obj;
  },
  getServer(vue, callback) {
    let url = server + '/szxxnew/serverurls';
    let self = this;
    vue.$http({
      url: url,
      method: 'get',
    }).then(function (res) {
      console.log(res);
      wsxfServer = res.data.wsxfServer;
      callback();
    }).catch(function (err) {
      console.log(err)
    })
  },
  verifyPhone(phone) {
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
      return false;
    } else {
      return true;
    }
  },
}




// WEBPACK FOOTER //
// ./src/assets/js/common.js